import React from "react";
import { Helmet } from "react-helmet";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import Hero from "../Components/home/Hero";
import OurServices from "../Components/home/OurServices";
import WhatWeDo from "../Components/home/WhatWeDo";
import WhoWeAre from "../Components/home/WhoWeAre";
import TrustedIndustries from "../Components/home/TrustedIndustries";
import Ratings from "../Components/home/Ratings";
import HowWeWork from "../Components/home/HowWeWork";
import Industries from "../Components/home/Industries";
import Testimonials from "../Components/home/Testimonials";
import FaqContact from "../Components/home/FaqContact";
import Newsletter from "../Components/home/Newsletter";
import homeFaqs from "../Components/home/homeFaqs";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "DataMetricks Consulting Pvt Ltd",
  url: "https://www.datametricks.com/",
  logo: "https://www.datametricks.com/logo.png",
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+91 7303946657",
      contactType: "Customer Service",
      email: "contact@datametricks.com",
      areaServed: "IN",
      availableLanguage: "English",
    },
  ],
  address: [
    {
      "@type": "PostalAddress",
      streetAddress: "A40, ITHUM TOWER, Industrial Area, Sector 62",
      addressLocality: "Noida",
      addressRegion: "Uttar Pradesh",
      postalCode: "201309",
      addressCountry: "IN",
    },
  ],
  sameAs: [
    "https://www.facebook.com/people/DataMetricks-Consulting-PvtLtd/61554350043470/",
    "https://www.instagram.com/datametricks_pvt_ltd/",
    "https://x.com/datametricks",
    "https://www.linkedin.com/company/datametricks-consulting-pvt-ltd/",
  ],
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: homeFaqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const Home = () => (
  <div>
    <SEOPage
      title="Website Design & Development Agency in Noida | Mobile App Development, SEO, DigitalMarketing"
      description="DataMetricks is a leading website design and development company in Noida, offering comprehensive digital solutions including mobile app development, SEO services, social media marketing, performance marketing, and CMS development. Grow your business with our expert-driven web and digital marketing services."
      canonicalUrl="https://www.datametricks.com/"
    />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <Hero />
      <OurServices />
      <WhatWeDo />
      <WhoWeAre />
      <TrustedIndustries />
      <Ratings />
      <HowWeWork />
      <Industries />
      <Testimonials />
      <FaqContact />
      <Newsletter />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default Home;
